module.exports = __webpack_public_path__ + "static/scale-model-of-lok'd-room-escapes-in-manchester-new-hampshire-ff2f063bd5cf93d8497a63933407564a.png";